"use client";

import { ADDRESS } from "@/lib/consts";

function useOpenMaps() {
  // Guarded because this runs during RENDER, and render now happens on the
  // server too: the <Hydration> gate used to return null server-side, so this
  // hook never executed there. `navigator` is only a Node global from Node 21
  // onwards, and this project pins no Node version (no engines field, no
  // .nvmrc, no vercel.json), so on Node 20 or below an unguarded read throws
  // "navigator is not defined" and 500s every route -- Footer calls this hook
  // and Footer is on every page.
  //
  // Defaulting to false is also more honest than testing the server's own UA:
  // on Node 22 `navigator.userAgent` is the string "Node.js/22", which is not
  // an Apple device. The value is only read inside the returned callback, which
  // runs on the client after hydration has recomputed it correctly.
  const isAppleDevice =
    typeof navigator !== "undefined" &&
    /iPhone|iPad|Macintosh|Mac OS X/i.test(navigator.userAgent);

  const encodedAddress = encodeURIComponent(ADDRESS);
  const appleMapsUrl = `https://maps.apple.com/?q=${encodedAddress}`;
  const googleMapsUrl = `https://maps.google.com/?q=${encodedAddress}`;

  return () => {
    window.open(isAppleDevice ? appleMapsUrl : googleMapsUrl, "_blank");
  };
}

export default useOpenMaps;
